import { RoleProtected } from '../Components/RoleProtected';
import UsersView from '../Components/UsersPageComp/Views/UsersView';

export default function UsersPage() {
  return (
    <RoleProtected allowedRoles={["Admin"]}>
      <UsersView />
    </RoleProtected>
  );
}